// src/components/ads/SideBanner.tsx
import React from 'react';
import Icon from '../common/Icon';

/** 자사 서비스 크로스 프로모션 배너 (사이드바용) */
const SideBanner: React.FC = () => (
    <a
        className="gh-promo"
        href="https://www.tax-mate.link/"
        target="_blank"
        rel="noopener noreferrer"
    >
        <span className="gh-promo__icon">
            <Icon name="coin" size={22} />
        </span>
        <span className="gh-promo__body">
            <span className="gh-promo__title">Tax-Mate</span>
            <span className="gh-promo__desc">연봉 실수령액부터 세금 계산까지 한번에</span>
        </span>
        <Icon name="chevronRight" size={16} strokeWidth={2.2} className="gh-promo__arrow" />
    </a>
);

export default SideBanner;
